import React from "react";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { useTranslations } from "@jugl-web/utils";
import { WhatsappPinDialogScreenToParametersMap } from "../../types";
import { WhatsappPinDialogContent } from "../../components/WhatsappPinDialogContent";
import { WhatsappPinDialogFooter } from "../../components/WhatsappPinDialogFooter";
import { isPinValid } from "../../utils";

export const CreatePinScreen: React.FC<{
  pin: string;
  onPinChange: (pin: string) => void;
}> = ({ pin, onPinChange }) => {
  const { t } = useTranslations();
  const { transitionTo } =
    useScreenTransitionManager<WhatsappPinDialogScreenToParametersMap>();

  return (
    <>
      <WhatsappPinDialogContent
        title={t({
          id: "client-support-page.enter-pin",
          defaultMessage: "Enter PIN",
        })}
        subtitle={t({
          id: "client-support-page.enter-correct-pin",
          defaultMessage:
            "Create 6-digit PIN which you'll be asked anytime when updating WhatsApp Account",
        })}
        pin={pin}
        onPinChange={onPinChange}
      />
      <WhatsappPinDialogFooter
        buttons={[
          {
            text: t({
              id: "common.proceed",
              defaultMessage: "Proceed",
            }),
            onClick: () => transitionTo({ name: "confirmPin" }),
            isDisabled: !isPinValid(pin),
          },
        ]}
      />
    </>
  );
};
